import { Box } from "@chakra-ui/react";
import Head from "next/head";
import { useEffect, useState } from "react";

import RouteViewer from "@/components/general/desarrollo/Seleccion2D/RouteViewer";
import Desarrollo from "@/sections/desarrollos/Desarrollo";
import Footer from "@/sections/home/Footer";
import Header from "@/sections/home/Header";

const LayoutDesarrollo = ({ develop, id, name, listDevs, favorites, opinions }) => {
    const [url, setUrl] = useState("");
    const [param, setParam] = useState("");
    const [isRouteViewer, setIsRouteViewer] = useState(false);

    useEffect(() => {
        // tomar el desarrollo y ponerlo en el storage para redirigir cuando se loggee
        const lastVisited = JSON.stringify({
            name,
            id,
        });
        localStorage.setItem("app.navigation.lastVisited", lastVisited);
        setUrl(`https://grupoguia.mx/desarrollo/${name}`);
    }, []);

    useEffect(() => {
        if (url !== "") {
            const filterURL = url.split("/");
            setParam(filterURL[filterURL.length - 1]);
        }
    }, [url]);

    return (
        <>
            <Head>
                <title>{develop ? develop.name : name} | Desarrollo | Grupo Guía </title>
                {/* Must be the HTML <link> element - a React <Link> renders an <a>, and an
                    anchor inside <head> makes the browser close head early, dumping the
                    rest of the metadata (including Next's head-count marker) into <body>
                    and crash-looping the head manager. */}
                <link rel="alternate" href={url} hrefLang="es-mx" />
                {param === "soareapartments" ? (
                    <meta
                        name="title"
                        content="Soaré Apartments en Zapopan | desarrollo en preventa"
                    />
                ) : param === "torremm" ? (
                    <meta name="title" content="Torre MM en Guadalajara | desarrollo en preventa" />
                ) : param === "hereditlifestylelegacy" ? (
                    <meta
                        name="title"
                        content="Heredit Lifestyle Legacy en Guadalajara | desarrollo en preventa"
                    />
                ) : param === "beriliosquare" ? (
                    <meta
                        name="title"
                        content="Heredit Berilo SQUARE en Guadalajara | desarrollo en preventa"
                    />
                ) : param === "coranta" ? (
                    <meta
                        name="title"
                        content="Heredit Coranta en Guadalajara | desarrollo en preventa"
                    />
                ) : param === "vivento" ? (
                    <meta name="title" content="VIVENTO en Zapopan | desarrollo en preventa" />
                ) : param === "torreverenna" ? (
                    <meta
                        name="title"
                        content="TORRE VERENNA en Zapopan | desarrollo en preventa"
                    />
                ) : null}
                {param === "soareapartments" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario Soare en Guadalajara. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "torremm" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario Torre MM en Guadalajara. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "hereditlifestylelegacy" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario Heredit Lifestyle Legacy en Guadalajara. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "beriliosquare" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario Heredit Berilo SQUARE en Guadalajara. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "coranta" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario Heredit Coranta en Guadalajara. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "vivento" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario VIVENTO en Zapopan. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : param === "torreverenna" ? (
                    <meta
                        name="description"
                        content="Descubre el lujoso desarrollo inmobiliario TORRE VERENNA en Zapopan. Con opciones de vida de lujo, servicios y comodidades, y una ubicación privilegiada en el corazón de la ciudad. Programa tu visita guiada hoy mismo."
                    />
                ) : null}
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta property="og:url" content={"https://grupoguia.mx/desarrollo/" + name} />
                <meta property="og:title" content={develop?.name} />
                <meta
                    property="og:image"
                    content={
                        develop?.cover_image
                            ? develop.cover_image
                            : "https://media.grupoguia.mx/assets/home-page/fichas/nodisponible.webp"
                    }
                />
            </Head>
            {isRouteViewer ? (
                <RouteViewer
                    koppiProps={develop?.external_props?.koppi}
                    setIsRouteViewer={setIsRouteViewer}
                    developmentId={develop?.development_id}
                    phoneNumber={
                        develop.external_props?.vision?.whatsapp ||
                        develop.external_props?.vision?.contact_phone
                    }
                />
            ) : (
                <>
                    <Header />

                    <Box>
                        <Desarrollo
                            city={name}
                            dataDevelopment={develop}
                            listDevs={listDevs}
                            favorites={favorites}
                            opinions={opinions}
                            setIsRouteViewer={setIsRouteViewer}
                        />
                    </Box>

                    {/* Footer Section */}
                    <Box>
                        <Footer esGuiaRent={false} />
                    </Box>
                </>
            )}
        </>
    );
};

export default LayoutDesarrollo;
